import { userService } from '@libs/data-access/queries'
import { DropdownMenu, TopNavbar, Avatar, Tooltip } from '@libs/ui/ds'
import { useAppNavBarTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentMembershipSelector } from 'snap-redux/modules/memberships/selectors'

import { UserMenuDropdownContent } from './UserMenuDropdownContent'

export const UserMenuNavItem: FC = () => {
  const { t } = useAppNavBarTranslation()
  const currentUser = userService.user.useFetchCurrentUser()
  const currentMembership = useSelector(getCurrentMembershipSelector)

  return (
    <DropdownMenu
      dropdownWidth='m'
      dropdownPosition='bottom-end'
      dropdownHeight='xl'
    >
      <DropdownMenu.Target>
        <Tooltip label={t('userMenu.description')}>
          <TopNavbar.Item data-testid='navbar-profile'>
            <Avatar
              src={currentUser?.data?.avatar_urls?.thumb}
              labels={[
                currentMembership?.firstname || '',
                currentMembership?.lastname || ''
              ]}
              size='s'
            />
          </TopNavbar.Item>
        </Tooltip>
      </DropdownMenu.Target>
      <DropdownMenu.Dropdown>
        <UserMenuDropdownContent currentMembership={currentMembership} />
      </DropdownMenu.Dropdown>
    </DropdownMenu>
  )
}
